export const ConstConfig = {
  apiPath: '/api',
  authApiPath: '/api_passport',
  qiniuCdn: 'https://images.snsports.cn',
  qiniuUpload: 'https://upload.qiniup.com',
  accept: 'image/jpeg,image/gif,image/png,image/bmp',
  wxAppId: 'wx83d351356eb8c592',
  siteUrl: 'http://www.snsports.cn',
  payUrl: 'https://www.snsports.cn/m/wechat-pay/index.html'
}
